<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import {cssVariables} from '../utils/CSSVariables';
    import { get } from "svelte/store";
    import {currentTable} from "../stores/tablesStore";
    import Layout from '../controllers/Layout';
 
    export let seat = 1;
    export let hidden = true;

    export function setHidden(value)
    {
        hidden = value;
    }
    
    let xOffset;
    let yOffset;

    onMount(async () => 
    {
        let tableType = get(currentTable).table_type;
        xOffset = Layout[tableType]["seat" + seat].dealerMarkerOffset[0];
        yOffset = Layout[tableType]["seat" + seat].dealerMarkerOffset[1];
	});
    

</script>

{#if hidden != "true" && hidden != true}
<div class="pokerDealer" use:cssVariables={{xOffset, yOffset}}>
    <img class="dealer" src={"/assets/dealer.png"}>
</div>
{/if}


<style>
    .pokerDealer {
        width: 25px;
        height: 25px;
        margin: 0px;
        padding: 0px;
        position: absolute; 
        left:  calc(var(--xOffset) * 1px);
        top:  calc(var(--yOffset) * 1px);        
    }
    .dealer {
        width: 25px;
        height: 25px;
    }
</style>